import { theme } from '@garnish/constants';

export const CIRCLE_STROKE_COLOR = theme.colors.OPACITY.KALE.DARKER;
export const CIRCLE_STROKE_WIDTH = 2;
export const CIRCLE_FILL_COLOR = theme.colors.OPACITY.KALE.LIGHTER;
